import React, { Component } from "react";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import VideoRecorder from "../../components/VideoRecorder";
import AddLogoText from "./AddLogoText";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import {
  Button,
  Collapse,
  Card,
  CardContent,
  LinearProgress,
  TextField
} from "@material-ui/core";
import ThemeButton from "../../components/ThemeButton";
import Loading from "../../components/Loading";
import ChipInput from "material-ui-chip-input";
import { FaLaptop } from "react-icons/fa";
import EmailInstruction from "../../components/Reusable/EmailInstruction";
import { toast } from "react-toastify";
import Colors from "../../constants/colors";
import {
  sendVideoToEmail,
  saveVideo,
  toggleSendVariable,
  sendMultipleEmails
} from "../../Redux/Actions/videos";
import {
  VideoState,
  EmailVideo,
  VideoSave,
  MultiEmail
} from "../../Redux/Types/videos";
import { AuthState } from "../../Redux/Types/auth";
import * as Constants from "../../constants/constants";
import "react-tabs/style/react-tabs.css";
import { reg } from "../../constants/emailRegEx";
import VideocamIcon from "@material-ui/icons/Videocam";
import "./style.css";
import fileUploadIcon from "../../assets/uploadCircle.png";
import Header from "../../components/Header/Header";
import {Storage, Auth} from "aws-amplify";
import { localStoragePut } from "../../util/localStorage";
import { v4 as uuid } from "uuid";
import { withRouter } from "../../utils/withRouter";

const isLocalAuth = process.env.REACT_APP_LOCAL_AUTH === 'true';

type IProps = {
  auth: AuthState;
  history: any;
  videoUser: VideoState;
  savedVideoId: string;
  progressEmail: boolean;
  sendVideoToEmail: (video: EmailVideo) => void;
  saveVideo: (video: VideoSave) => void;
  toggleSendVariable: () => void;
  sendMultipleEmail: (emailVideoObj: any) => void;
  location: any;
};
type IState = {
  file: any;
  url: string;
  files: any;
  loading: boolean;
  videoRecord: any;
  title: string;
  urlRecord: string;
  recordFile: any;
  emails: Array<string>;
  recieverEmail: string;
  fileProgress: boolean;
  videoProgress: boolean;
  progressFile: number;
  progressVideo: number;
  addLogoText: boolean;
  thumbnail: any;
  uploadPreviewUrl: string;
  thumbnailPreviewUrl: string;
  isThumbnailOpen: boolean;
};

class UploadRecord extends Component<IProps, IState> {
  onDrop: (files: any) => void;
  uploadPreviewVideo: any;
  thumbnailCanvas: any;
  constructor(props: any) {
    super(props);
    this.onDrop = files => {
      this.props.toggleSendVariable();
      if (this.state.uploadPreviewUrl) {
        URL.revokeObjectURL(this.state.uploadPreviewUrl);
      }
      if (this.state.thumbnailPreviewUrl) {
        URL.revokeObjectURL(this.state.thumbnailPreviewUrl);
      }
      const uploadPreviewUrl = URL.createObjectURL(files[0]);
      this.setState({
        files,
        uploadPreviewUrl,
        thumbnail: "",
        thumbnailPreviewUrl: ""
      });
    };
    this.state = {
      file: {},
      url: "",
      files: [],
      recordFile: [],
      loading: false,
      videoRecord: "",
      title: "",
      urlRecord: "",
      recieverEmail: "",
      fileProgress: false,
      videoProgress: false,
      progressFile: 0,
      progressVideo: 0,
      emails: [],
      thumbnail: "",
      addLogoText: false,
      uploadPreviewUrl: "",
      thumbnailPreviewUrl: "",
      isThumbnailOpen: true
    };
  }
  titleNameHandler = (event: any) => {
    this.setState({
      title: event.target.value
    });
  };
  emailHandler = (event: any) => {
    this.setState({
      recieverEmail: event.target.value
    });
  };

  handleChipAdd = (email: any) => {
    if (!reg.test(email)) {
      toast.error("Not a valid email");
      return;
    }
    this.setState({ emails: [...this.state.emails, email] });
  };
  handleDeleteChip = (delEmail: any) => {
    this.setState({
      emails: this.state.emails.filter((email: string) => email !== delEmail)
    });
  };
  sendMultipleEmail = () => {
    if (this.state.emails.length === 0) {
      toast.error("No email provided");
      return;
    } else if (!this.props.savedVideoId) {
      toast.error("No video saved try again");
      return;
    } else {
      const emails = this.state.emails.join();
      const emailVideoObj = {
        recieverEmail: emails,
        videoId: this.props.savedVideoId
      };
      this.props.sendMultipleEmail(emailVideoObj);
      this.setState({ emails: [] });
    }
  };
  componentWillUnmount() {
    if (this.state.uploadPreviewUrl) {
      URL.revokeObjectURL(this.state.uploadPreviewUrl);
    }
    if (this.state.thumbnailPreviewUrl) {
      URL.revokeObjectURL(this.state.thumbnailPreviewUrl);
    }
  }
  uploadFileHandler = async () => {
    if (this.state.title === "") {
      toast.warn("Enter a video title");
      return;
    }
    if (!this.state.thumbnail) {
      toast.warn("Capture a thumbnail before saving");
      return;
    }
    this.setState({ fileProgress: true, progressFile: 0, videoProgress: true });
    try {
      const uploadFn = isLocalAuth ? localStoragePut : Storage.put;
      const progressCb = (progressEvent: { loaded: number; total: number; }) => {
        let uploaded: number = (progressEvent.loaded * 100) / progressEvent.total;
        this.setState({ progressFile: uploaded });
      };
      const fileResponse: any = await uploadFn(this.state.files[0].name, this.state.files[0], isLocalAuth
        ? { progressCallback: progressCb }
        : { level: "protected" as any, progressCallback: progressCb }
      );
      this.setState({ urlRecord: fileResponse.key });
      const thumbnailKey = await this.uploadThumbnail(
        `${uuid()}-thumbnail.jpg`,
        this.state.thumbnail
      );
      let identityId = 'local';
      if (!isLocalAuth) {
        const currentUser = await Auth.currentUserCredentials();
        identityId = currentUser.identityId;
      }
      const video = {
        title: this.state.title,
        url: fileResponse.key,
        userId: this.props.auth!.user!._id,
        thumbnail: thumbnailKey,
        isVideo: true,
        identityId,
      };
      this.setState({ fileProgress: false, videoProgress: false });
      this.props.saveVideo(video);
    } catch (error: any) {
      console.error(error);
      this.setState({ fileProgress: false, videoProgress: false });
      toast.error("Failed to save video, please try again");
      return;
    }
  };

  submitEmail = () => {
    if (this.props.savedVideoId === "") {
      return toast.warn("Please save a video");
    } else if (this.state.recieverEmail === "") {
      return toast.warn("Add an Email");
    } else if (!reg.test(this.state.recieverEmail)) {
      return toast.warn("Invalid Email");
    } else {
      const recieverEmail = this.state.recieverEmail;
      const video = {
        videoId: this.props.savedVideoId,
        recieverEmail
      };
      this.props.sendVideoToEmail(video);
      this.setState({ recieverEmail: "" });
    }
  };
  uploadThumbnail = (filename: string, blob: Blob) => {
    return new Promise<string>((resolve, reject) => {
      const uploadFn = isLocalAuth ? localStoragePut : Storage.put;
      uploadFn(filename, blob, isLocalAuth
        ? { contentType: "image/jpeg" }
        : { level: "protected" as any, contentType: "image/jpeg" }
      )
        .then((response: any) => resolve(response.key))
        .catch((error: any) => reject(error));
    });
  };
  captureUploadThumbnail = () => {
    if (!this.uploadPreviewVideo || !this.thumbnailCanvas) {
      toast.error("Preview not ready yet");
      return;
    }
    if (this.uploadPreviewVideo.readyState < 2) {
      toast.warn("Wait for the video to load before capturing");
      return;
    }
    const context = this.thumbnailCanvas.getContext("2d");
    if (!context) {
      toast.error("Thumbnail canvas not available");
      return;
    }
    this.thumbnailCanvas.width = 1280;
    this.thumbnailCanvas.height = 720;
    context.drawImage(this.uploadPreviewVideo, 0, 0, 1280, 720);
    try {
      this.thumbnailCanvas.toBlob((blob: any) => {
        if (!blob) {
          toast.error("Failed to capture thumbnail");
          return;
        }
        if (this.state.thumbnailPreviewUrl) {
          URL.revokeObjectURL(this.state.thumbnailPreviewUrl);
        }
        const thumbnailPreviewUrl = URL.createObjectURL(blob);
        this.setState({ thumbnail: blob, thumbnailPreviewUrl });
        toast.success("Thumbnail captured");
      }, "image/jpeg");
    } catch (error) {
      console.error("Error capturing thumbnail", error);
      toast.error("Failed to capture thumbnail");
    }
  };
  removeUploadThumbnail = () => {
    if (this.state.thumbnailPreviewUrl) {
      URL.revokeObjectURL(this.state.thumbnailPreviewUrl);
    }
    this.setState({ thumbnail: "", thumbnailPreviewUrl: "" });
  };
  toggleThumbnailCard = () => {
    this.setState(prevState => ({
      isThumbnailOpen: !prevState.isThumbnailOpen
    }));
  };

  navigateToVideos = () => {
    this.props.history.push("/videos");
  };
  moveToAddLogoText = () => {
    this.setState({ addLogoText: true });
  };
  render() {
    let { videoSaved, loading } = this.props.videoUser;
    return (
      <>
        <Header
          styles={{
            backgroundImage:
              "linear-gradient(-90deg, rgb(97, 181, 179), rgb(97, 181, 179), rgb(252, 179, 23))"
          }}
        />
        <div className="recordMainContainer">
          <div
            className="backToDashboard"
            onClick={() => this.props.history.push("/")}
          >
            <i className="fas fa-arrow-left" style={{ marginRight: 8 }} />
            Back to Dashboard
          </div>
          <Tabs defaultIndex={this.props.location.show === "upload" ? 1 : 0}>
            <TabList>
              <Tab>
                <div>
                  <VideocamIcon />
                  {Constants.RECORD_WITH_CAMERA}
                </div>
              </Tab>
              <Tab style={{ bottom: "-2.2px" }}>
                <div>
                  <FaLaptop id="videoTabIcon" style={iconStyle} />
                  {Constants.UPLOAD_FROM_COMPUTER}
                </div>
              </Tab>
            </TabList>
            <TabPanel>
              {!this.state.addLogoText ? (
                <VideoRecorder
                  getBlob={(blob: any) => {
                    this.props.toggleSendVariable();
                    this.setState({ videoRecord: blob }, () =>
                      this.setState({ addLogoText: true })
                    );
                  }}
                />
              ) : (
                <AddLogoText videoToEdit={this.state.videoRecord} />
              )}
            </TabPanel>
            <TabPanel>
              <div className="uploadPanelBorder">
                <div className="wrapperUploadPanel">
                  <Dropzone onDrop={this.onDrop}>
                    {({ getRootProps, getInputProps }) => (
                      <section className="container">
                        <div
                          {...getRootProps({ className: "dropzone" })}
                          style={{
                            textAlign: "center",
                            cursor: "pointer",
                            margin: "auto",
                            width: 100
                          }}
                        >
                          <input {...getInputProps()} />
                          <img
                            src={fileUploadIcon}
                            style={{ width: 80, margin: "auto" }}
                            alt="upload"
                          />
                        </div>
                        <aside>
                          <p
                            style={{
                              marginTop: 20,
                              textAlign: "center",
                              fontFamily: "Poppins",
                              fontWeight: "bold"
                            }}
                          >
                            {Constants.CLICK_AND_DRAG}
                          </p>
                          {this.state.files.map((file: any) => (
                            <div key={file.name}>
                              <div className="fileInformationDiv">
                                <p>File Name: {file.name}</p>
                                <p>Size: {file.size} bytes</p>
                              </div>
                              {this.state.uploadPreviewUrl && (
                                <Card className="thumbnailCard">
                                  <CardContent className="thumbnailCardContent">
                                    <div className="cardHeaderRow">
                                      <h3 className="addLogoMessage">
                                        Set Thumbnail
                                      </h3>
                                      <button
                                        type="button"
                                        className="cardToggleLink"
                                        onClick={this.toggleThumbnailCard}
                                      >
                                        {this.state.isThumbnailOpen
                                          ? "Collapse"
                                          : "Expand"}
                                      </button>
                                    </div>
                                    <Collapse
                                      in={this.state.isThumbnailOpen}
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <div className="thumbnailPicker">
                                        <div className="thumbnailPickerContent">
                                          <div className="thumbnailPickerVideo">
                                            <video
                                              ref={ref => {
                                                this.uploadPreviewVideo = ref;
                                              }}
                                              src={this.state.uploadPreviewUrl}
                                              controls
                                              width="100%"
                                            />
                                            <div className="thumbnailPickerControls">
                                              <div className="thumbnailButtonRow">
                                                <Button
                                                  style={{
                                                    color: "#fff",
                                                    backgroundColor: "#ff4301"
                                                  }}
                                                  onClick={this.captureUploadThumbnail}
                                                >
                                                  USE CURRENT FRAME
                                                </Button>
                                                <Button
                                                  style={{
                                                    color: "#fff",
                                                    backgroundColor: "rgb(34, 185, 255)"
                                                  }}
                                                  onClick={this.removeUploadThumbnail}
                                                  disabled={!this.state.thumbnailPreviewUrl}
                                                >
                                                  REMOVE THUMBNAIL
                                                </Button>
                                              </div>
                                              <p className="thumbnailHint">
                                                Pause or scrub the video before capturing.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                        {this.state.thumbnailPreviewUrl && (
                                          <div className="thumbnailPreviewWrap">
                                            <img
                                              className="thumbnailPreview"
                                              src={this.state.thumbnailPreviewUrl}
                                              alt="thumbnail preview"
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </Collapse>
                                  </CardContent>
                                </Card>
                              )}
                              <canvas
                                ref={ref => {
                                  this.thumbnailCanvas = ref;
                                }}
                                style={{ display: "none" }}
                              />
                              <div id="formInput">
                                {videoSaved === null && (
                                  <div>
                                    {this.state.fileProgress && (
                                      <LinearProgress
                                        variant="determinate"
                                        value={this.state.progressFile}
                                      />
                                    )}
                                    <TextField
                                      name="name"
                                      value={this.state.title}
                                      onChange={this.titleNameHandler}
                                      placeholder="Give your videon an amazing title"
                                      type="text"
                                      label="Video Title"
                                      fullWidth
                                      margin="normal"
                                      InputLabelProps={{
                                        shrink: true
                                      }}
                                      style={{ margin: "40px 0px" }}
                                    />
                                    <ThemeButton
                                      style={{
                                        background: Colors.themeBlue,
                                        color: Colors.white
                                      }}
                                      disabled={
                                        this.state.videoProgress || loading
                                      }
                                      onClick={this.uploadFileHandler}
                                      name="Save Video"
                                    />
                                  </div>
                                )}
                                {videoSaved === true && (
                                  <div>
                                    <div>
                                      <EmailInstruction heading="Reciever Email" />
                                      <TextField
                                        placeholder="Enter email address"
                                        fullWidth
                                        type="text"
                                        value={this.state.recieverEmail}
                                        name="recieverEmail"
                                        InputLabelProps={{
                                          shrink: true
                                        }}
                                        onChange={this.emailHandler}
                                      />
                                    </div>
                                    <ThemeButton
                                      onClick={this.submitEmail}
                                      name={`${Constants.SEND_THROUGH_EMAIL}`}
                                      style={{
                                        backgroundColor: Colors.themeGreen,
                                        color: Colors.white
                                      }}
                                    />
                                    <div className="formGroupMultiple">
                                      <EmailInstruction heading="Broadcast" />
                                      <ChipInput
                                        value={this.state.emails}
                                        placeholder="Enter email and press enter"
                                        fullWidth
                                        onAdd={chips =>
                                          this.handleChipAdd(chips)
                                        }
                                        onDelete={chip =>
                                          this.handleDeleteChip(chip)
                                        }
                                      />
                                    </div>
                                    <div>
                                      <ThemeButton
                                        style={{
                                          backgroundColor: Colors.themeGreen,
                                          color: Colors.white
                                        }}
                                        onClick={this.sendMultipleEmail}
                                        name="Broadcast"
                                      />
                                    </div>
                                    <ThemeButton
                                      style={{
                                        background: Colors.themeBlue,
                                        color: Colors.white,
                                        marginTop: "30px"
                                      }}
                                      onClick={this.navigateToVideos}
                                      name="Done"
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </aside>
                      </section>
                    )}
                  </Dropzone>
                  <div style={{ marginLeft: "50%" }}>
                    {loading && <Loading />}
                    {this.props.progressEmail && <Loading />}
                  </div>
                </div>
              </div>
            </TabPanel>
          </Tabs>

        </div>
      </>
    );
  }
}

const iconStyle = {
  padding: 0,
  width: "1em",
  height: "1em"
};
const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
    videoUser: state.video,
    savedVideoId: state.video.savedVideoId,
    progressEmail: state.video.progressEmail
  };
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    sendVideoToEmail: (video: EmailVideo) => dispatch(sendVideoToEmail(video)),
    saveVideo: (video: VideoSave) => dispatch(saveVideo(video)),
    toggleSendVariable: () => dispatch(toggleSendVariable()),
    sendMultipleEmail: (emailVideoObj: MultiEmail) =>
      dispatch(sendMultipleEmails(emailVideoObj))
  };
};
export default withRouter<any, any>(
  connect(mapStateToProps, mapDispatchToProps)(UploadRecord)
);
